import { EVENT_TYPES } from '../component/MatomoTagManger/MatomoTagManager.events';
import { pushEvent } from '../store/Matomo/Matomo.action';

const mapStateToProps = (args, callback) => {
    const [state] = args;

    return {
        ...callback(...args),
        cartTotals: state.CartReducer.cartTotals
    };
};
const mapDispatchToProps = (args, callback) => {
    const [dispatch] = args;

    return {
        ...callback(...args),
        pushEvent: (event, data) => dispatch(pushEvent(event, data))
    };
};

export const aroundAfterAddToCart = (args, callback, instance) => {
    const {
        product,
        originalProduct: { sku },
        product: { variants },
        quantity,
        configurableVariantIndex,
        pushEvent,
        cartTotals: {
            items
        } = {}
    } = instance.props;

    if (instance.validate()) {
        const productToAdd = variants
            ? { ...product, configurableVariantIndex, sku }
            : { ...product, sku };

        const totalQuantity = items.reduce((acc, product) => {
            if (product.sku === productToAdd.sku) {
                return acc + product.qty;
            }

            return acc;
        }, 0) + quantity;

        if (totalQuantity <= productToAdd.salable_qty) {
            pushEvent(EVENT_TYPES.ADD_TO_CART, {
                product: productToAdd,
                quantity,
                configurableVariantIndex
            });
        }
    }

    return callback(...args);
};

export default {
    'Component/AddToCart/Container/mapDispatchToProps': {
        function: mapDispatchToProps
    },
    'Component/AddToCart/Container/mapStateToProps': {
        function: mapStateToProps
    },
    'Component/AddToCart/Container': {
        'member-function': {
            addProductToCart: aroundAfterAddToCart
        }
    }
};
